import React, { useEffect, useRef, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useSignUp } from "./Hooks";

const SignUp = () => {
  const { form, setForm, mobile, loading, signUp } = useSignUp();
  return (
    <div className="login row">
      <div className="box col-md-4">
        <div className="display">
          <img
            style={{ width: "124px" }}
            src={require("../../Assets/images/logo.png")}
          />
        </div>

        <div>
          <div>
            <div className="font2">ثبت نام</div>
            <div className="font3">لطفا مشخصات خود را وارد کنید</div>
          </div>
          <div>
            <input
              placeholder="نام و نام خانوادگی"
              onChange={({ target: { value } }) => {
                setForm({ ...form, fullname: value });
              }}
            />
            <input
              //   placeholder="0912000000000"
              //   className=""
              defaultValue={mobile}
              disabled={true}
              className="form-control"
            />
          </div>

          <button
            onClick={signUp}
            className="primary-btn"
            style={{ fontSize: "15px" }}
          >
            {loading ? <Spinner size="sm" /> : "ثبت نام"}
          </button>
          <p className="text-center mt-3 mb-1 fs-12 color-text-2">
            <span> </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
